import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IChatMessage, IChatSlice } from '../../interfaces/interfaces'
import { ChatType } from 'interfaces'

const ChatSliceState: IChatSlice = {
  messages: undefined,
  usersInfoInChat: [],
  chatEnabled: false,
  showChat: true,
  socket: undefined,
  roomId: undefined,
  chatType: ChatType.public,
  messageCount: 0,
}

export const chatSlice = createSlice({
  name: 'chat',
  initialState: ChatSliceState,
  reducers: {
    setMessages: (state, action: PayloadAction<IChatMessage[]|undefined>) => {
      state.messages = action.payload
    },
    setUsersInfoInChat: (state, action: PayloadAction<any>) => {
      state.usersInfoInChat = action.payload
    },
    setChatEnabled: (state, action: PayloadAction<boolean>) => {
      state.chatEnabled = action.payload
    },
    setShowChat: (state, action: PayloadAction<boolean>) => {
      state.showChat = action.payload
    },
    setSocket: (state, action: PayloadAction<any>) => {
      state.socket = action.payload
    },
    setRoomId: (state, action: PayloadAction<any>) => {
      state.roomId = action.payload
    },
    setChatType: (state, action: PayloadAction<ChatType>) => {
      state.chatType = action.payload
    },
    setMessageCount: (state, action: PayloadAction<number>) => {
      state.messageCount = action.payload
    },
    setClearChatSlice: () => {
      return ChatSliceState
    },
  },
})

export const {
  setMessages,
  setUsersInfoInChat,
  setChatEnabled,
  setShowChat,
  setSocket,
  setClearChatSlice,
  setRoomId,
  setChatType,
  setMessageCount,
} = chatSlice.actions

export default chatSlice.reducer